import { Component, OnInit } from '@angular/core';

import { UsersService } from '../_services/users.service';
import { ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs';
import { environment } from '../../environments/environment';

import * as XLSX from 'xlsx/xlsx.mjs';

interface User {
  name: string;
  username: string;
  email: string;
  status: string;
  phone_number: string;
  location: {
    city: string;
    state: string;
    country: string;
  }
}

class DataTablesResponse {
  data: any[] = [];
  draw: number = 0;
  recordsFiltered: number = 0;
  recordsTotal: number = 0;
}

@Component({
  selector: 'app-users',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.css'],
  standalone: false
})
export class UsersComponent implements OnInit {
  dtOptions: DataTables.Settings = {};
  users: User[];
  search_key: string;
  dtTrigger: Subject<any> = new Subject();
  usersExport: User[];
  isLoadingUsersExport: boolean = false;
  constructor(
    private userService: UsersService,
    private toastr: ToastrService) { }

  ngOnInit(): void {
    const that = this;
    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 10,
      serverSide: true,
      processing: true,
      order: [[5, 'desc']],
      language: {
        searchPlaceholder: 'Name|Phone|Email'
      },
      ajax: (dataTablesParameters: any, callback) => {
        this.search_key = dataTablesParameters.search.value;
        this.userService.userListing(dataTablesParameters).
          subscribe({
            next: (resp) => {
            that.users = resp.data.user_listing;
            // console.log(resp);
            callback({
              recordsTotal: resp.data.total_count,
              recordsFiltered: resp.data.total_count,
              data: []
            });
            // Calling the DT trigger to manually render the table
            // this.dtTrigger.next();
          },error: (err) => {
            // console.log(err);
            this.toastr.error(err.error);
            callback({
              processing: false,
              recordsTotal: 0,
              recordsFiltered: 0,
              data: []
            });
          }
        });
      },
      columns: [{ data: 'name' }, { data: 'username' }, { data: 'phone_number' }, { data: 'email' }, { data: 'subscription_detail.status' }, { data: 'venue_subscription_detail.name' }, { data: 'venue_subscription_expiration' }]
      // columnDefs: [{ "orderable": false, "targets": 5 }]
    };
  }

  // download users excel
  exportTOExcel() {
    const header = [
      { label: 'Name', id: 'name' },
      { label: 'Username', id: 'username' },
      { label: 'Email', id: 'email' },
      { label: 'Phone number', id: 'phone_number' },
      { label: 'City', id: 'city' },
      { label: 'State', id: 'state' },
      { label: 'Country', id: 'country' },
      { label: 'Status', id: 'status' }
    ];
    const dateStr = new Date().toJSON().slice(0,10);
    const exportUserFileName = `RadarQR_${environment.production ? 'Prod' : 'Dev'}_Users_${dateStr}.xlsx`;
    const headerRow = header.map(h => h.label);
    const dataRow = this.usersExport.map(user => 
      header.map(h => user[h.id])
    );
    const ws: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet([headerRow, ...dataRow]);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    XLSX.writeFile(wb, exportUserFileName);
    this.isLoadingUsersExport = false;
  }

  downloadUsers() {
    this.isLoadingUsersExport = true;
    this.userService.getUsersList()
      .subscribe({
        next: (response) => {
          this.usersExport = response.data;
          this.exportTOExcel();
        }, 
        error: (err) => {
          console.error(err);
          this.isLoadingUsersExport = false;
        }
      });
  }

}
